import useWebGLLostStore from "store/web-gl-store";

export function useWebGLMode(uniqueId: string) {
  const lostCharts = useWebGLLostStore(s => s.lostCharts);
  const isLost = lostCharts.has(uniqueId);

  const useGPU = !isLost;
  const wrapperKey = `${useGPU ? "GPU" : "CPU"}-${uniqueId}`;

  return { useGPU, wrapperKey };
}

let patchApplied = false;
const patchedCanvases = new WeakSet<HTMLCanvasElement>();

export function patchWebGLLost() {
  if (patchApplied) return;
  patchApplied = true;

  const originalGetContext = HTMLCanvasElement.prototype.getContext;

  HTMLCanvasElement.prototype.getContext = function patchedGetContext(
    contextId: string,
    options?: CanvasRenderingContext2DSettings
  ): any {
    const ctx = originalGetContext.call(this, contextId, options);

    if (contextId === "webgl" || contextId === "webgl2") {
      const canvas = this as HTMLCanvasElement;

      if (ctx && !patchedCanvases.has(canvas)) {
        patchedCanvases.add(canvas);

        canvas.addEventListener(
          "webglcontextlost",
          evt => {
            evt.preventDefault();

            const div = canvas.closest("[data-chart-id]");
            if (!div) return;

            const id = div.getAttribute("data-chart-id");
            if (!id) return;

            const store = useWebGLLostStore.getState();
            if (store.lostCharts.has(id)) return;

            store.addLostChart(id);
          },
          { passive: false }
        );
      }
    }

    return ctx;
  };
}
